export default __webpack_public_path__ + "locales/sr-Latn-RS/Ldap.json?hash=d448621032a83e37971f481113d89ddf";